import React, { useState, useEffect } from 'react'
import { toFormData } from '../../../utils/convert.util';
import request from '../../../services/request.service';


function ListItem({ item }) {

    return (
        <div className="notice_div">
            <p className="title">{item.title || ''}</p>
            <p className="text01" > 
                <span dangerouslySetInnerHTML={{ __html: item.content }}></span>
            </p>
            <br />
            <p className="date">{item.date || ''}</p>
        </div>
    );
}


function Notice() {

    const [list, setList] = useState([]);

    useEffect(() => {
        _get_list();
    }, []);

    const _get_list = async () => {
        const param = { "b_type": "notice" };
        const rsp = await request.post('/api/board/board_list.php', toFormData(param)).then(response => response.data)
        if (rsp.result < 0) {
            return null;
        } else {
            setList(rsp.list);
            return rsp;
        }
    }
    if (!list) return;

    return (
        <div className="s_inner">
            {list && list.map((item, index) => (<ListItem key={index} item={item} />))}
        </div>
    )
}
export default Notice;